<section class="title-text-content">
  <div class="container">
    <div class="content">
      <h2 id="{{ componentObject | titleToId }}">{{ componentObject.title }}</h2>
      <div class="content-text" [innerHTML]="componentObject.text"></div>
    </div>
  </div>
</section>
